// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 72016 ? "fc22d32c" : chunkId) + "." + {"1885":"15a4a59607ea27e4","53348":"95c82ef8bab21e14","72016":"7418f537f4cd4b02","92457":"079cfb498c5e13b2"}[chunkId] + ".js";
};